export const TAB_CONTROL_PANEL = {
  BAILIFFS: 'bailiffs',
  ADMIN: 'admin',
  ARCHIVE: 'archive'
};
